import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/26lights-logo.png'


const _hoisted_1 = { class: "toggle-button-wrapper" }
const _hoisted_2 = { class: "toggle-button-wrapper" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_5 = { class: "nav-text" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-text" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-text" }
const _hoisted_10 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_11 = { class: "nav-text" }
const _hoisted_12 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_13 = { class: "nav-text" }
const _hoisted_14 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_15 = ["href", "onClick"]
const _hoisted_16 = { class: "nav-text" }
const _hoisted_17 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_18 = { class: "nav-text" }
const _hoisted_19 = {
  key: 5,
  class: "nav-item"
}
const _hoisted_20 = { class: "nav-text" }
const _hoisted_21 = {
  key: 6,
  class: "nav-item"
}
const _hoisted_22 = { class: "nav-text" }
const _hoisted_23 = {
  key: 7,
  class: "nav-item"
}
const _hoisted_24 = { class: "nav-text" }
const _hoisted_25 = {
  key: 8,
  class: "nav-item"
}
const _hoisted_26 = { class: "nav-text" }
const _hoisted_27 = {
  key: 9,
  class: "nav-item"
}
const _hoisted_28 = { class: "nav-text" }
const _hoisted_29 = { class: "footer" }

import { ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { Icon } from "@iconify/vue";
import IconButton from "@/components/IconButton.vue";
import {
  isAdmin,
  isClient,
  isCFO,
  isEmployee,
  isFinancial,
} from "@/helpers/router/queries";
import { useQuery } from "@vue/apollo-composable";
import { GET_USER } from "@/graphql/user/queries";
import ButtonLogOut from "@/components/ButtonLogOut.vue";
import { useRoute } from "vue-router";
import { useIsWorkFullScreen } from "@/composables/useIsWorkFullScreen";


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

const { t } = useI18n({
  useScope: "global",
  inheritLocale: true,
});
const route = useRoute();

const { isWorkFullScreen } = useIsWorkFullScreen();

const isOnProjectPage = computed(() => {
  return route.matched.some(
    (match) => match.path === "/projects" || match.path === "/project/:id",
  );
});

const { result, refetch } = useQuery(GET_USER);

const user = computed(() => result.value?.user);
const isUserAdmin = computed(() => isAdmin(user.value?.accessRights));
const isUserCFO = computed(() => isCFO(user.value?.accessRights));
const isUserEmployee = computed(() => isEmployee(user.value?.accessRights));
const isUserClient = computed(() => isClient(user.value?.accessRights));
const isUserFinancial = computed(() => isFinancial(user.value?.accessRights));

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

watch(route, async (r) => {
  if (r?.name === "Verify") refetch();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(IconButton, {
        "icon-name": "material-symbols:menu",
        color: "primary",
        class: "toggle-button",
        onClick: toggleMenu
      })
    ]),
    _withDirectives(_createElementVNode("nav", {
      class: _normalizeClass(["side-bar", { hidden: !isMenuOpen.value }]),
      onClick: toggleMenu
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(IconButton, {
          "icon-name": "material-symbols:close",
          class: "toggle-button"
        })
      ]),
      _createVNode(_component_router_link, {
        to: "/",
        class: "home-link"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h1", { class: "title" }, [
            _createElementVNode("img", {
              class: "logo",
              src: _imports_0,
              alt: "My26"
            })
          ], -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_3, [
        (isUserEmployee.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/employee",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "material-symbols-light:dashboard-outline",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("titles.myDashboard")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/activity-feed",
            class: "router-link",
            "active-class": "router-link--active"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Icon), {
                icon: "material-symbols:flowsheet-outline",
                class: "nav-icon"
              }),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("titles.activityFeed")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/my-planning",
            class: "router-link",
            "active-class": "router-link--active"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Icon), {
                icon: "material-symbols:calendar-month",
                class: "nav-icon"
              }),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("titles.myPlanning")), 1)
            ]),
            _: 1
          })
        ]),
        (isUserAdmin.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/admin",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "bi:clipboard-pulse",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)("titles.adminDashboard")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isUserAdmin.value || isUserFinancial.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: "/clients",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "bi:person-square",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)("titles.myClients")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isUserClient.value || isUserEmployee.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: "/projects",
                custom: ""
              }, {
                default: _withCtx(({ href, navigate }) => [
                  _createElementVNode("a", {
                    href: href,
                    onClick: navigate,
                    class: _normalizeClass({
              'router-link': true,
              'router-link--active': isOnProjectPage.value,
            })
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: "codicon:project",
                      class: "nav-icon"
                    }),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)("titles.myProjects")), 1)
                  ], 10, _hoisted_15)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isUserAdmin.value || isUserFinancial.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: "/invoicing",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "la:file-invoice-dollar",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)("titles.invoicing")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isUserEmployee.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
              _createVNode(_component_router_link, {
                to: "/timers",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "material-symbols:timer",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)("titles.timers")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isUserClient.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
              _createVNode(_component_router_link, {
                to: "/invoices",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "material-symbols:receipt-long",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)("titles.myInvoices")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isUserAdmin.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: "/revenue",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "streamline:money-graph-arrow-increase-ascend-growth-up-arrow-stats-graph-right-grow",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)("titles.revenueForecast")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isUserCFO.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
              _createVNode(_component_router_link, {
                to: "/cfo-dashboard",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "material-symbols:dashboard-outline",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)("titles.cfoDashboard")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (isUserAdmin.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
              _createVNode(_component_router_link, {
                to: "/templates",
                class: "router-link",
                "active-class": "router-link--active"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "material-symbols:flowsheet-outline",
                    class: "nav-icon"
                  }),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)("titles.templates")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(ButtonLogOut)
      ])
    ], 2), [
      [_vShow, !_unref(isWorkFullScreen)]
    ])
  ], 64))
}
}

})